import axios from 'axios';

export function uploadFile(url, file) {
  var options = { headers: { 'Content-Type': file.type } };
  return axios.put(url, file, options);
}
